// Typelizer digest ca9e1612310ccd0652fd57065ac707d8
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /password/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/password/new', {}, options),
    method: 'get',
  }),

  /** GET /password/edit */
  edit: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/password/edit', {}, options),
    method: 'get',
  }),

  /** PATCH /password */
  update: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/password', {}, options),
    method: 'patch',
  }),

  /** POST /password */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/password', {}, options),
    method: 'post',
  }),
}
